import { CuttingFacadeMaterial } from './cutting-facade-material.model';
import { CuttingFacade } from './cutting-facade.model';

export class FacadeView extends CuttingFacade {
  material: CuttingFacadeMaterial;

  constructor(pan?: any) {
    super(pan);
  }
}
